<template>
  <div class="home">
    <h1>欢迎使用后台系统</h1>
  </div>
</template>
<script>

  export default {
  }
</script>
<style scoped>
.home{
  text-align: center;
}
</style>
